import { isEmpty, get } from 'lodash';

/**
 * @type {function}
 * @desc Fetch geographic coordinates data from Google service using Google GeoCode API.
 * @example
 * import { geoCordsFromAddress } from 'services/geocode';
 *
 * const promise = geoCordsFromAddress( google, address );
 */
export const geoCordsFromAddress = ( google, address ) => {

    // get Geocoder constructor api from `google` API object
    const Geocoder = new google.maps.Geocoder();

    return new Promise( ( resolve, reject ) => {
        Geocoder.geocode( {  address }, ( res ) => {
			if( !isEmpty( get( res, '[0].geometry.location', {} ) ) ) {
				resolve( {
					lat: res[ 0 ].geometry.location.lat(),
					long: res[ 0 ].geometry.location.lng(),
				} );
			} else {
				reject();
			}
        } );
    } );

};
